import cities from '../../config/cities.json';
import countries from '../../config/countries.json';
import { Stack, TextField, MenuItem } from '@mui/material';
import { txt } from '../../services/translation';

export default function Address({value, onChange, required, spacing, sx}){

    const handleChange = e => {
        let copy = {...value};
        copy[e.target.name] = e.target.value;
        return onChange(copy);
    }

    const handleZipChange = e => {
        let copy = {...value};

        copy.zip = e.target.value;

        if(copy.zip.length === 5){
            copy.city = cities.find(c => c.code === copy.zip)?.name || '';
        }

        return onChange(copy);
    }

    return <Stack direction='column' spacing={spacing || 2} sx={sx || {}}>

        <TextField
            label={txt('address')}
            name='address'
            value={value?.address || ''}
            onChange={handleChange}
            required={required ? true : false}
            inputProps={{minLength: 3, maxLength: 500}}
            size='small'
        />

        <Stack direction='row' spacing={1}>

            <TextField
                label={txt('zipCode')}
                name='zip'
                value={value?.zip || ''}
                onChange={handleZipChange}
                required={required ? true : false}
                inputProps={{minLength: 2, maxLength: 10}}
                size='small'
                sx={{flex: 1}}
            />

            <TextField
                label={txt('city')}
                name='city'
                value={value?.city || ''}
                onChange={handleChange}
                required={required ? true : false}
                inputProps={{minLength: 2, maxLength: 100}}
                size='small'
                sx={{flex: 2}}
            />

        </Stack>

        <TextField
            label={txt('country')}
            name='country'
            select
            size='small'
            value={value?.country || ''}
            onChange={handleChange}
            required={required ? true : false}
        >
            {countries.map(c => 
                <MenuItem key={c.code} value={c.code}>
                    {c.name.toUpperCase()}
                </MenuItem>    
            )}
        </TextField>

    </Stack>
}
